import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function BollywoodCasino2() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "btable2";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      // gameName={"CARDS 32B"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container bollywood"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
            Bollywood Casino 2
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span> */}
      {/* <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>165250424212228</span>
            </small>
          </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul> */}
      {/* <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>165250424212228</span>
            </span>
          </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box">
             
              </div>
           */}
      {/* <div className="casino-video-cards">
              <div>
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                A.Don
                <div className="casino-nation-book d-md-none" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Don", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Don", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Don", casinoData, dispatch, "lay")}
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Don", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Don")}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                B.Amar Akbar Anthony
                <div className="casino-nation-book d-md-none" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Amar Akbar Anthony", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Amar Akbar Anthony", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Amar Akbar Anthony", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Amar Akbar Anthony", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "Amar Akbar Anthony"
                )}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                C.Sahib Bibi Aur Ghulam
                <div className="casino-nation-book d-md-none" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Sahib Bibi Aur Ghulam", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Sahib Bibi Aur Ghulam", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Sahib Bibi Aur Ghulam", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Sahib Bibi Aur Ghulam", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "Sahib Bibi Aur Ghulam"
                )}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                D.Dharam Veer
                <div className="casino-nation-book d-md-none" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Dharam Veer", casinoData, dispatch, "back")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Dharam Veer", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Dharam Veer", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Dharam Veer", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Dharam Veer")}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                E.Kis Kis ko Pyaar Karoon
                <div className="casino-nation-book d-md-none" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    "Kis Kis ko Pyaar Karoon",
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <span className="casino-odds">
                  {getOddForEntity("Kis Kis ko Pyaar Karoon", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet("Kis Kis ko Pyaar Karoon", casinoData, dispatch, "lay")
                }
              >
                <span className="casino-odds">
                  {getOddForEntity(
                    "Kis Kis ko Pyaar Karoon",
                    casinoData,
                    false
                  )}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(
                  casinoPlData,
                  "Kis Kis ko Pyaar Karoon"
                )}
              </div>
            </div>
            <div className="casino-odd-box-container">
              <div className="casino-nation-name">
                F.Ghulam
                <div className="casino-nation-book d-md-none" />
              </div>
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Ghulam", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Ghulam", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Ghulam", casinoData, dispatch, "lay")}
              >
                <span className="casino-odds">
                  {getOddForEntity("Ghulam", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
              <div className="casino-nation-book text-center d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Ghulam")}
              </div>
            </div>
          </div>
          <div className="casino-table-box mt-3">
            <div className="casino-table-left-box left-odd-box">
              <div className="casino-odd-box-container">
                <div className="casino-nation-name">
                  Odd
                  <div className="casino-nation-book text-danger d-md-none" />
                </div>
                {/* <div className="casino-odds-box back"> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Odd", casinoData, dispatch, "back")}
                >
                  <span className="casino-odds">
                    {getOddForEntity("Odd", casinoData, true)}
                  </span>
                </div>
                {/* <div className="casino-odds-box lay"> */}
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Odd", casinoData, dispatch, "lay")}
                >
                  <span className="casino-odds">
                    {getOddForEntity("Odd", casinoData, false)}
                  </span>
                </div>
                {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Odd")}
                </div>
              </div>
            </div>
            <div className="casino-table-right-box right-odd-box">
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {getOddForEntity("Dulha Dulhan K-Q", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Dulha Dulhan K-Q", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">Dulha Dulhan K-Q</span>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(
                    casinoPlData,
                    "Dulha Dulhan K-Q"
                  )}
                </div>
              </div>
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {getOddForEntity("Barati J-A", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Barati J-A", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">Barati J-A</span>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Barati J-A")}
                </div>
              </div>
            </div>
          </div>
          <div className="casino-table-box mt-3">
            <div className="casino-table-left-box ">
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {getOddForEntity("Red", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Red", casinoData, dispatch, "back")}
                >
                  <div className="casino-odds">
                    <span className="card-icon ms-1">
                      <span className="card-red ">{"{"}</span>
                    </span>
                    <span className="card-icon ms-1">
                      <span className="card-red ">[</span>
                    </span>
                  </div>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Red")}
                </div>
              </div>
              <div className="aaa-odd-box">
                <div className="casino-odds text-center">
                  {getOddForEntity("Black", casinoData, true)}
                </div>
                {/* <div className="casino-odds-box back casino-odds-box-theme"> */}
                <div
                  className={`casino-odds-box back casino-odds-box-theme ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Black", casinoData, dispatch, "back")}
                >
                  <div className="casino-odds">
                    <span className="card-icon ms-1">
                      <span className="card-black ">{"}"}</span>
                    </span>
                    <span className="card-icon ms-1">
                      <span className="card-black ">]</span>
                    </span>
                  </div>
                </div>
                {/* <div className="casino-nation-book text-center" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Black")}
                </div>
              </div>
            </div>
            <div className="casino-table-right-box right-cards">
              <h4 className="w-100 text-center mb-2">
                <b>{getOddForEntity("Card J", casinoData, true)}</b>
              </h4>
              <div className="card-odd-box">
                <div
                  className={`${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Card J", casinoData, dispatch)}
                >
                  <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/J.png" />
                  <div className="casino-nation-book text-center">
                    {getCasinoPlExposureByRunner(casinoPlData, "Card J")}
                  </div>
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div
                  className={`${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Card Q", casinoData, dispatch)}
                >
                  <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/Q.png" />
                  <div className="casino-nation-book text-center">
                    {getCasinoPlExposureByRunner(casinoPlData, "Card Q")}
                  </div>
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div
                  className={`${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Card K", casinoData, dispatch)}
                >
                  <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/K.png" />
                  <div className="casino-nation-book text-center">
                    {getCasinoPlExposureByRunner(casinoPlData, "Card K")}
                  </div>
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div
                  className={`${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() => setBet("Card A", casinoData, dispatch)}
                >
                  <img src="https://g1ver.sprintstaticdata.com/v49/static/front/img/cards/A.png" />
                  <div className="casino-nation-book text-center">
                    {getCasinoPlExposureByRunner(casinoPlData, "Card A")}
                  </div>
                </div>
                <div className="casino-nation-book" />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/btable2">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">B</span>
              <span className="result result-b">E</span>
              <span className="result result-b">F</span>
              <span className="result result-b">C</span>
              <span className="result result-b">D</span>
              <span className="result result-b">E</span>
              <span className="result result-b">F</span>
              <span className="result result-b">E</span>
              <span className="result result-b">B</span>
              <span className="result result-b">B</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
